export const number = (value: unknown): string => value === null || value === undefined || !Number.isFinite(Number(value)) ? '—' : new Intl.NumberFormat('pt-BR').format(Number(value));
export const money = (value: unknown): string => value === null || value === undefined || !Number.isFinite(Number(value)) ? 'Sem dados' : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value));
export const date = (value: unknown): string => {
  if (!value) return '—';
  const raw = String(value);
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  const parsed = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(raw);
  if (dateOnly && (parsed.getFullYear() !== Number(dateOnly[1]) || parsed.getMonth() !== Number(dateOnly[2]) - 1 || parsed.getDate() !== Number(dateOnly[3]))) return raw;
  return Number.isNaN(parsed.getTime()) ? String(value) : new Intl.DateTimeFormat('pt-BR', { dateStyle: 'medium' }).format(parsed);
};
export const percent = (value: unknown): string => value === null || value === undefined ? '—' : `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(Number(value))}%`;

